export default __webpack_public_path__ + "static/media/warning-circle-fill.c5acf793.svg";